// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__om9FS","left":"InfoRow_left__1GS15"};